import PropTypes from 'prop-types';
import React from 'react';
import {
  DEFAULT_DEAL_BUSINESS_IMG_HEIGHT,
  DEFAULT_DEAL_BUSINESS_IMG_WIDTH,
} from '../../../../config/setup/setup';
import { replaceImageLogo } from '../../../../helpers/image';

const ImageLogo = ({ dealId, webAddress, item, bundle, alt }) => {
  const imageLogo = (
    <>
      <img
        alt={alt}
        className="image-logo img-fluid"
        height={DEFAULT_DEAL_BUSINESS_IMG_HEIGHT}
        loading="lazy"
        src={bundle ? item?.imageUrl : replaceImageLogo(dealId, item)}
        width={DEFAULT_DEAL_BUSINESS_IMG_WIDTH}
      />
      <style jsx>{`
        .image-logo {
          border-radius: 5px;
          width: 160px;
        }
      `}</style>
    </>
  );

  if (!webAddress) return imageLogo;

  return (
    <a
      className="company-logo--link text-center"
      href={webAddress}
      rel="noreferrer noopener"
      target="_blank"
    >
      {imageLogo}
      <style jsx>{`
        .company-logo--link {
          display: inline-block;
          text-decoration: none;
          border-radius: 5px;
        }
      `}</style>
    </a>
  );
};

ImageLogo.propTypes = {
  alt: PropTypes.string,
  bundle: PropTypes.bool,
  dealId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  item: PropTypes.object,
  webAddress: PropTypes.string,
};

ImageLogo.defaultProps = {
  alt: '',
  bundle: false,
  dealId: '',
  item: {},
  webAddress: '',
};

export default ImageLogo;
